export default {
  menu: 'Categories',
  title: 'Categories',

  general: {
    labels: {
      none: 'None',
      name: 'Category title',
      parent: 'Parent category',
      insertAttribute: 'Add new feature',
      editAttribute: 'Edit new feature',
      chooseAttribute: 'Choose a new feature',
      suggestAttributes: 'Suggested attributes',
      withoutCategory: 'Without category',
      productCount: '{count} products',
      product_category: 'Product category',
      service_category: 'Service category',
      no_category: 'Without category'
    },

    notifications: {
      insert: {
        success: 'Category created successfully',
        error: 'Adding category was associated with an error'
      },
      edit: {
        success: 'Category edited successfully',
        error: 'Editing category failed'
      },
      delete: {
        success: 'Category deleted successfully',
        error: 'Delete category associated failed'
      }
    },

    validators: {
      attributeExist: 'Attribute { name } is in this category',
      noChange: 'No changes have been made'
    },

    confirmations: {
      delete: {
        title: 'Delete Category',
        body: 'If you delete this category, all products in this category will be deleted. Are you sure you want to delete {name}? '
      }
    }
  },

  list: {
    title: 'Categories'
  },

  insert: {
    title: 'Add new category'
  },

  edit: {
    title: 'Edit Category'
  }
}
